import * as types from '../constants';

export const setIsClickedMenuButton = isClickedMenuButton => ({
  type: types.SET_IS_CLICKED_MENU_BUTTON,
  payload: isClickedMenuButton,
});

export const setIsHoverMenu = isHoverMenu => ({
  type: types.SET_IS_HOVER_MENU,
  payload: isHoverMenu,
});

export const setSidebarItem = sidebarItem => ({
  type: types.SET_SIDEBAR_ITEM,
  payload: sidebarItem,
});

export const setHotelItem = hotelItem => ({
  type: types.SET_HOTEL_ITEM,
  payload: hotelItem,
});